if (!customElements.get('nyc-cart-acknowledgment')) {
  class NycCartAcknowledgment extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.scope = this.closest('[data-nyc-checkout-scope]');
      this.form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;

      if (!this.checkbox || !this.scope) return;

      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleLockedInteraction = this.handleLockedInteraction.bind(this);

      this.checkbox.addEventListener('change', this.handleChange);
      this.form?.addEventListener('submit', this.handleSubmit, true);
      this.scope.addEventListener('click', this.handleLockedInteraction, true);

      this.updateCheckoutState();
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.handleChange);
      this.form?.removeEventListener('submit', this.handleSubmit, true);
      this.scope?.removeEventListener('click', this.handleLockedInteraction, true);
    }

    get accepted() {
      return Boolean(this.checkbox?.checked);
    }

    get checkoutButtons() {
      return this.scope?.querySelectorAll('[data-nyc-checkout-button]') || [];
    }

    get acceleratedCheckoutContainers() {
      return this.scope?.querySelectorAll('[data-nyc-accelerated-checkout]') || [];
    }

    handleChange() {
      this.updateCheckoutState();
    }

    handleSubmit(event) {
      const submitter = event.submitter;
      const isCheckoutSubmission = submitter?.name === 'checkout' || submitter?.matches?.('[data-nyc-checkout-button]');

      if (isCheckoutSubmission && !this.accepted) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.focusCheckbox();
      }
    }

    handleLockedInteraction(event) {
      if (this.accepted) return;

      const acceleratedCheckout = event.target.closest?.('[data-nyc-accelerated-checkout]');
      if (!acceleratedCheckout) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.focusCheckbox();
    }

    focusCheckbox() {
      this.checkbox?.focus({ preventScroll: true });
      this.checkbox?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    updateCheckoutState() {
      const accepted = this.accepted;

      this.checkoutButtons.forEach((button) => {
        const disabledByCartState = button.dataset.nycCartEmpty === 'true';
        button.disabled = disabledByCartState || !accepted;
        button.setAttribute('aria-disabled', String(button.disabled));
      });

      this.acceleratedCheckoutContainers.forEach((container) => {
        container.toggleAttribute('inert', !accepted);
        container.classList.toggle('is-nyc-checkout-locked', !accepted);
        container.setAttribute('aria-disabled', String(!accepted));
      });
    }
  }

  customElements.define('nyc-cart-acknowledgment', NycCartAcknowledgment);
}
